import { Link } from "react-router-dom";

const IMAGES = [
  {
    url: "/img/alleyway-hoodie.webp",
    label: "FRAME / 001",
    title: "AFTER HOURS",
    note: "shot in the shadows.",
  },
  {
    url: "/img/skater-sitting.webp",
    label: "FRAME / 002",
    title: "ORIGINS",
  },
  {
    url: "/img/la-crew.webp",
    label: "FRAME / 003",
    title: "THE BLOCK",
  },
];

export default function Lookbook() {
  return (
    <section data-testid="lookbook" className="border-b border-white/20 bg-ink">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-20 pb-6">
        <div className="flex items-end justify-between flex-wrap gap-3">
          <div>
            <p className="text-blood text-xs tracking-[0.3em] font-mono mb-2">// LOOKBOOK / VOLUME 01</p>
            <h2 className="font-anton uppercase text-bone text-5xl sm:text-7xl tracking-tighter leading-[0.9]">
              SHOT IN THE <span className="text-blood">SHADOWS</span>
            </h2>
          </div>
          <Link
            to="/shop"
            data-testid="lookbook-shop-link"
            className="text-bone text-xs tracking-[0.3em] uppercase font-mono hover:text-blood"
          >
            SHOP THE LOOK →
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-12 grid-rows-2 gap-3 px-4 sm:px-6 lg:px-8 pb-20">
        <figure className="col-span-12 lg:col-span-7 row-span-2 relative group overflow-hidden border border-white/10 aspect-[4/5] lg:aspect-auto">
          <img src={IMAGES[0].url} alt="" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
          <figcaption className="absolute bottom-6 left-6 right-6 flex justify-between items-end">
            <div>
              <p className="text-blood text-[10px] tracking-[0.4em] font-mono">{IMAGES[0].label}</p>
              <h3 className="font-anton uppercase text-bone text-4xl sm:text-6xl tracking-tighter">{IMAGES[0].title}</h3>
            </div>
            <span className="font-marker text-bone text-3xl rotate-[-4deg]">{IMAGES[0].note}</span>
          </figcaption>
        </figure>

        <figure className="col-span-12 sm:col-span-6 lg:col-span-5 relative group overflow-hidden border border-white/10 aspect-[4/3]">
          <img src={IMAGES[1].url} alt="" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-transparent to-transparent" />
          <figcaption className="absolute bottom-4 left-4 right-4">
            <p className="text-blood text-[10px] tracking-[0.4em] font-mono">{IMAGES[1].label}</p>
            <h3 className="font-anton uppercase text-bone text-3xl tracking-tighter">{IMAGES[1].title}</h3>
          </figcaption>
        </figure>

        <figure className="col-span-12 sm:col-span-6 lg:col-span-5 relative group overflow-hidden border border-white/10 aspect-[4/3]">
          <img src={IMAGES[2].url} alt="" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-transparent to-transparent" />
          <figcaption className="absolute bottom-4 left-4 right-4">
            <p className="text-blood text-[10px] tracking-[0.4em] font-mono">{IMAGES[2].label}</p>
            <h3 className="font-anton uppercase text-bone text-3xl tracking-tighter">{IMAGES[2].title}</h3>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
